import React from "react";
import { useLocation } from "react-router-dom";
import ReportViewPage from "./ReportViewPage";
import { ActivityItem } from "../AllActivities/types";

/**
 * Type guard to validate ActivityItem structure
 */
const isValidReportData = (data: any): data is ActivityItem => {
  return data && 
         typeof data === 'object' && 
         typeof data.id === 'string' &&
         typeof data.reportName === 'string' &&
         typeof data.category === 'string';
};

/**
 * Wrapper component that extracts report data from router state and handles validation
 */
const ReportViewWrapper: React.FC = () => {
  const location = useLocation();
  
  // Safely extract and validate report data from router state
  const reportData = React.useMemo(() => {
    const stateData = location.state?.reportData;
    return isValidReportData(stateData) ? stateData : undefined;
  }, [location.state]);

  return <ReportViewPage reportData={reportData} />;
};

export default ReportViewWrapper;
